import { inject, Injectable } from '@angular/core';
import { MessageService, ToastMessageOptions } from 'primeng/api';

@Injectable({
  providedIn: 'root',
})
export class ToasterService {
  private messageService = inject(MessageService);
  constructor() {}

  public success(message: string, ...args: ToastMessageOptions[]) {
    this.messageService.add({
      ...args[0],
      severity: 'success',
      summary: 'Success',
      detail: message,
    });
  }

  public error(message: string, ...args: ToastMessageOptions[]): void {
    this.messageService.add({ ...args[0], severity: 'error', summary: 'Error', detail: message });
  }

  public warning(message: string, ...args: ToastMessageOptions[]) {
    this.messageService.add({ ...args[0], severity: 'warn', summary: 'Warn', detail: message });
  }

  public info(message: string, ...args: ToastMessageOptions[]) {
    this.messageService.add({ ...args[0], severity: 'info', summary: 'Info', detail: message });
  }

  public custom(key: string, severity: string, message: string, ...args: ToastMessageOptions[]) {
    this.messageService.add({
      ...args[0],
      key,
      sticky: true,
      severity,
      summary: message,
      closable: false,
    });
  }

  public clear(key: string): void {
    this.messageService.clear(key);
  }
}
